import React from "react";
import { getTypeIcon } from "./getTypeIcon";
import { StepItemProps } from "../../Types/types";

const StepItem: React.FC<StepItemProps> = ({
  step,
  handleStepClick,
  language,
}) => {
  return (
    <div
      key={step.id}
      onClick={() => handleStepClick(step.id)}
      className="bg-white p-4 rounded-md shadow text-black cursor-pointer"
    >
      <div className="flex gap-2">
        <p className="text-purple">{getTypeIcon(step.type)}</p>
        <p>{language === "cz" ? step.label : step.labelEN || step.label}</p>
      </div>
    </div>
  );
};

export default StepItem;
